export default __webpack_public_path__ + "static/media/GR3 2B-1C-2EC.b6644b49.jpg";